// =====================================
// 利用状況確認・変更ステップ
// =====================================
export const NEXT_DELIVERY_CHANGE_INPUT = '次回発送内容の変更'
export const NEXT_DELIVERY_CHANGE_CONFIRM = '次回発送内容の変更確認'
export const NEXT_DELIVERY_CHANGE_COMPLETE = '次回発送内容の変更完了'